export const Bio={
    name:"Ramya Chitturi",
    roles:[
        "Full Stack Developer",
        "Backed Developer",
        "Programmer",
    ],
    description:
     "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
    github:"https://github.com/Ramyachitturi888",
    resume:
    "https://drive.google.com/file/d/1Tg7zftMFZCxQcOAZcJBMjlZBwOJn8ktO/view?usp=drive_link",
    linkedin:"linkedin.com/in/ramya-chitturi-884023139",
};

export const skills=[
    {
        title: "Frontend",
        skills: [
            {
                name:"React Js",
                image:
                "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
            },
            {
                name: "Angular Js",
                image:
                  "https://camo.githubusercontent.com/8886130b3d8aba95dbdd7c4f9a41029606424cc06d1873c1ced87dd55a222fef/68747470733a2f2f616e67756c61722e696f2f6173736574732f696d616765732f6c6f676f732f616e67756c61722f616e67756c61722e737667",
              },
              {
                name: "HTML",
                image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
              },
              {
                name: "CSS",
                image:
                  "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
              },
              {
                name: "JavaScript",
                image:
                  "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
              },

        ],
    },
    {
        title: "Backend",
        skills:[
            {
                name:"Java",
                image : "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
            },
            {
                name: "Python",
                image:
                  "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
              },
              {
                name: "MySQL",
                image:
                  "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
              },
              {
                name: "MongoDB",
                image:
                  "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
              },
              {
                name: "Node Js",
                image: "https://nodejs.org/static/images/logo.svg",
              },
        ],
    },
    {
        title:"DevOps",
        skills:[
            {
                name: "AWS",
                image:
                  "https://download.logo.wine/logo/Amazon_Web_Services/Amazon_Web_Services-Logo.wine.png",
              },
              {
                name: "Docker",
                image:
                  "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
              },
              {
                name: "Jenkins",
                image:
                  "https://toppng.com/uploads/preview/jenkins-logo-11609365847mufysaivph.png",
              },
              {
                name: "Kubernetes",
                image:
                  "https://upload.wikimedia.org/wikipedia/commons/0/00/Kubernetes_%28container_engine%29.png",
              },
        ],
    },
    {
        title: "Machine Learning",
        skills: [
          {
            name: "Python",
            image:
              "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
          },
          {
            name: "Tenserflow",
            image:
              "https://static-00.iconduck.com/assets.00/tensorflow-icon-1911x2048-1m2s54vn.png",
          },
          {
            name: "Sk Learn Kit",
            image:
              "https://upload.wikimedia.org/wikipedia/commons/thumb/0/05/Scikit_learn_logo_small.svg/2560px-Scikit_learn_logo_small.svg.png",
          },
        ] ,
    },
    {
        title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://e7.pngegg.com/pngimages/713/558/png-clipart-computer-icons-pro-git-github-logo-text-logo-thumbnail.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image:
          "https://static-00.iconduck.com/assets.00/postman-icon-497x512-beb7sy75.png",
      },
    ],
    },

];
export const experiences = [
    {
      id: 0,
      img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/neurobit.jpeg?alt=media&token=1cacbb7b-e5ea-4efb-9b3d-f5a31b9564ad",
      role: "Senior Software Engineer",
      company: "Informatica",
      date: "Sep 2022 - Nov 2023",
      desc: "Redesigned and developed a Lineage calculation, significantly improving its performance by achieving a 60% faster execution compared to the existing implementation, even with millions of records.Actively involved in Analysis, Design, Development, System Testing and User Acceptance Testing. ● Developed the application using Java 8 and implemented its features like lambda Expressions, Streams, functional interfaces, collectors, default methods, type interfaces, for each.Used a multithreaded environment to run processes asynchronously using different future calls to access the data.Spring Boot MicroServices were developed using Microservices architecture with RESTFUL and Apache Kafka. Worked on Spark and ElasticSearch for DPM data loading and Lineage calculation. Used Maven is used for build scripts and configured log4j, log files. Involved in System Testing, Integration Testing, and Production Testing on WebLogic Server. ",
      skills: [
        "Java",
        "Spring boot",
        "Spring MVC",
        "Java Scripts",
        "Rest API",
        "MongoDB",
        "SQL",
        "Spark",
        "Elasticsearch",
        "Docker",

      ],
      doc: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/Screenshot%20from%202024-01-25%2022-38-31.png?alt=media&token=2785903f-1a4e-41f5-afd2-6adcfe56d058",
    },
];

export const education = [
    {
      id: 0,
      img: 
      "https://drive.google.com/file/d/1BDyYDujYmrsSFmGJa3Z0g7RnL2eCoElZ/view?usp=drive_link",
      school: "PES Institute of Technology, Bangalore",
      date: "Sep 2016 - Apr 2018",
      grade: "8.0 CGPA",
      degree: "Master of Computer Applications - MCA, Computer Science and Engineering",
    },
];

export const projects = [
  {
    id: 11,
    title: "DecisionHub",
    date: "Jan 2024 - Dec 2023",
    description:
      "A Rule Builder application “Decision Hub” that empowers Business Analysts to create, save, and visualize decision strategies. Provide a no-code rule writing experience and visual representation to test these rules in real-time and observe the calculations at each step.",
    image:
      "https://github.com/rishavchanda/DecisionHub/raw/master/assets/testRule.jpg",
    tags: [
      "React Js",
      "PostgressSQL",
      "Node Js",
      "Express Js",
      "Redux",
      "React Flow",
    ],
    category: "web app",
    github: "https://github.com/rishavchanda/DecisionHub",
    webapp: "https://decisionhub.netlify.app/",
  },
];

export const TimeLineData = [
  { year: 2018, text: "Started my journey" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
];



